<dx-switch [disabled]="disabled" [(value)]="value!" width="auto"
  switchedOnText="{{ switchOnLabel }}" switchedOffText="{{ switchOffLabel }}"
  (valueChange)="onSelfChangeValue(value);"
  (onFocusIn)="(!!onFocusIn && onFocusIn())"
  (onFocusOut)="(!!onFocusOut && onFocusOut())"> </dx-switch>
